import { apiUrl } from '../../../../settings'

export const getAbstractDashSingleUrl = (id) => {
  return apiUrl + `/get-single-abstract/${id}`
}

// export const getAbstractDashActivityUrl = (id) => {
//   return apiUrl + `/abstract/get-abstract-activity/${id}`
// }
export const allAbstractUrl = () => {
  return apiUrl + `/allAbstract`
}

export const getAbstractDashNoteCountUrl = (id) => {
  return apiUrl + `/abstract/get-abstract-note-count/${id}`
}

export const listAbstractDashNotesUrl = () => {
  return apiUrl + '/abstract/list-abstract-notes'
}

export const deleteAbstractDashNoteUrl = () => {
  return apiUrl + '/abstract/delete-abstract-note'
}

export const updateAbstractDashStatusUrl = () => {
  return apiUrl + '/abstract/update-abstract-status'
}
export const addAbstractViewNoteUrl = () => {
  return apiUrl + '/abstract/add-note'
}
export const AbstractViewNotesUrl = () => {
  return apiUrl + '/abstract/notes-list'
}
export const DeleteAbstractViewUrl = () => {
  return apiUrl + `/deleteAbstractView`
}
export const WithdrawalAbstractUrl = () => {
  return apiUrl + '/api/withdrawalAbstract'
}
export const AbstractlistActivityUrl = () => {
  return apiUrl + '/abstract/activity-list'
}
export const addReviewerInAbstractUrl = () => {
  return apiUrl + `/api/addReviewerInAbstract`
}
export const processAbstractPaymentUrl = () => {
  return apiUrl + '/api/processAbstractPayment'
}


